import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PaginationData, PaginationRange } from 'tiime-material';

import { ApiCommonService } from '@api-services/api-common.service';
import { ApiAlertError } from '@decorators/api-alert-error';
import { AuditEntityType } from '@enums/audit-entity-type.enum';
import { HttpHelper } from '@helpers/http.helper';
import { Audit, AuditJson, AuditSerialized } from '@models/audit';

@Injectable({
  providedIn: 'root'
})
export class AuditApiService extends ApiCommonService<Audit> {
  readonly resourceUrl: string = `api/v1/expert/audits`;

  fromJson(json: AuditJson): Audit {
    return Audit.fromJson(json);
  }

  toJson(audit: Audit): AuditSerialized {
    return Audit.toJson(audit);
  }

  @ApiAlertError()
  getAudits(
    entityType: AuditEntityType,
    entityId: number,
    range: PaginationRange = PaginationRange.withPageSize(5),
    properties?: string[],
    startDate?: string,
    endDate?: string
  ): Observable<PaginationData<Audit>> {
    const url = `${this.resourceUrl}/${entityType}/${entityId}`;
    let params = HttpHelper.createHttpParams();
    if (properties) {
      params = HttpHelper.setParam('properties', properties.join(','));
    }
    if (startDate || endDate) {
      params = HttpHelper.setParam('recorded_at', HttpHelper.dateFilter(startDate, endDate));
    }

    return this.getPaginated(range, params, url);
  }
}
